import { AxiosProgressEvent } from "axios";
import { UPLOAD_FILE } from "../../routes";
import imageFileAxios from "../../imageFileAxios";

const uploadImage = async (file: any) => {
  let formData = new FormData();
  formData.append("image", file);

  try {
    return (await imageFileAxios.post(UPLOAD_FILE, formData)).data;
  } catch (error: unknown) {
    return false;
  }
};

export default uploadImage;
